import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormSubtract = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormSubtract' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M6,12 L18,12' />
  </StyledIcon>
);
